var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h3',[_vm._v("Reports and Dashboards")]),_c('b-row',[_c('b-col',[_c('workloads-summary')],1),_c('b-col',[_c('course-plan')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }